import { createApiClient, createAuthApiClient } from '@mybusinessmate/api-client';
import { expiringFetch } from './session-expiry';

/** '' = same-origin relative URLs (dev, via the Vite proxy). Production sets VITE_API_URL. */
const API_URL = import.meta.env.VITE_API_URL ?? '';

/** Typed Hono RPC client for everything except /api/auth/*. */
export const api = createApiClient(API_URL, { fetch: expiringFetch });

/** Typed Better Auth client for /api/auth/*. */
export const authClient = createAuthApiClient(API_URL);
